import Radio from 'backbone.radio';
import DialogAccountInviteAccept from '@/views/dialogs/account_invite_accept';

    var globalCh = Radio.channel('global');
    /**
     * Show a dialog to notifiy an invitee they have
     * accepted an invite from an account
     */
    export default function show_account_invite_accept_dialog(account, type) {
        /**
         * DialogAccountInviteAccept expects an account model
         */
        account.set('invite_type', type);
        var view = new DialogAccountInviteAccept({
            model: account
        });
        globalCh.request('showDialog', view);
    }

